<template>
  <div id="s-menu" class="s-base">
    <v-card class="s-panel" max-width="1000">
      <v-card-title class="s-title">サーバ一覧画面</v-card-title>
      <v-container>
        <v-row align-center justify-center no-gutters>
          <v-col class="py-6">
            <v-data-table
              :headers="tableHeaders"
              :items="serverDataList"
              class="server-list-table"
            >
            </v-data-table>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col class="pt-6">
            <span>※サーバ追加・変更時にはシステム管理者にご連絡ください。</span>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col class="py-6">
            <v-btn color="primary" @click="backToMenu()" width="100"
              >戻る</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <request-error-dialog
      :requestErrorDialogFlag.sync="dialog.requestError"
      :httpStatus="httpStatus"
      :message="requestErrorDialogMessage"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { NETWORK_ERROR } from "../router";
import serverModule, { ServerDataList } from "../store/ServerModule";
import RequestErrorDialog from "./RequestErrorDialog.vue";

@Component({
  components: {
    "request-error-dialog": RequestErrorDialog,
  },
})
export default class ServerList extends Vue {
  /** 各ダイアログのフラグ値 */
  dialog = {
    requestError: false,
  };

  /** httpステータスコード */
  httpStatus = 200;

  /** 画面遷移時にデータ読み込みのエラー判定 */
  mountedOk = false;

  /** リクエストエラーダイアログのテキスト変数 */
  requestErrorDialogMessage = "";

  /** v-data-table用のヘッダープロパティ */
  tableHeaders = [
    { text: "サーバ名", value: "serverName", width: "30%" },
    { text: "サーバID", value: "serverId", width: "15%" },
    { text: "IPアドレス", value: "ipAddress", width: "30%" },
    { text: "サーバ種別", value: "useType.useTypeName" },
  ];

  /**
   * Storeからサーバデータリストを取得
   * @return {ServerDataList} サーバデータリスト
   */
  get serverDataList(): ServerDataList {
    if (this.httpStatus !== 200 && this.mountedOk !== true) {
      return [];
    }
    return serverModule.serverDataList;
  }

  /**
   * メニューページに遷移する。
   */
  backToMenu(): void {
    this.$router.back();
  }

  /**
   * データをDBからStoreに取り込む
   */
  async loadDataToStore(): Promise<void> {
    try {
      await serverModule.getServerDataList();
    } catch (error) {
      if (error instanceof Error) {
        if (error.message === "500") {
          // 500 Internal Server Error
          this.httpStatus = 500;
          this.dialog.requestError = true;
        } else if (error.message === "401") {
          // 401 Unauthorized
          this.httpStatus = 401;
          this.dialog.requestError = true;
        } else {
          // 運用上起こってはいけないエラー
          this.$router.push({ name: error.message });
        }
      } else {
        // 運用上起こってはいけないエラー
        this.$router.push({ name: NETWORK_ERROR });
      }
    }
  }

  /**
   * サーバ一覧画面へ遷移した時に実行
   */
  async mounted() {
    await this.loadDataToStore();
    if (this.httpStatus === 200) {
      this.mountedOk = true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/common.scss";

.server-list-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  ::v-deep th {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    border: none;
    background-color: #2b72de;
    word-break: break-all;
    span {
      font-size: 17px;
      font-weight: 400;
      color: #ffffff;
    }
    .v-icon {
      color: #d4d4d4 !important;
    }
  }
  ::v-deep td {
    word-break: break-all;
  }
  ::v-deep tr:nth-child(even) {
    background-color: #f0ffff;
  }
}
</style>
